import React from 'react';
import { useInputWrapperContext } from './InputWrapper.context.mjs';

function InputsGroupFieldset({ children, role, ...rest }) {
  const ctx = useInputWrapperContext();
  if (!ctx) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement("div", { role, "aria-labelledby": ctx.labelId, "aria-label": ctx.ariaLabel, "aria-describedby": ctx.describedBy, ...rest }, children);
}

export { InputsGroupFieldset };
